<template>
  <div class="cardprofile">
    <!-- <div class="textContainer">
      <h6>{{ cardData.fullname }}</h6>
    </div> -->
    <div class="header">
        <h4>{{ cardData.name }}</h4>
      <!-- <img class="big" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7mMNz8YCBvYmnr3BQUPX__YsC_WtDuAevwg&s"/> -->
    </div>
    <div class="body">
      <div class="cardRow">
        <h6>EMAIL</h6>
      </div>
      <p style="margin-bottom: 10px;">{{ cardData.email }}</p>
      <div class="cardRow">
        <h6>PHONE</h6>
      </div>
      <p>{{ cardData.phone }}</p>
    </div>
    <div class="body" style="border-bottom-color: transparent; overflow: scroll;">
      <div class="cardRow">
        <h6>DEPARTMENT</h6>
      </div>
      <p style="margin-bottom: 10px;">{{ cardData.assessorDepartmentId && cardData.assessorDepartmentId.departmentName ? cardData.assessorDepartmentId.departmentName : '-' }}</p>
      <div class="cardRow">
        <h6>SECTION</h6>
      </div>
      <p style="margin-bottom: 10px;">{{ cardData.assessorSectionId && cardData.assessorSectionId.sectionName ? cardData.assessorSectionId.sectionName : '-' }}</p>
      <div class="cardRow">
        <h6>EXPERTISE</h6>
      </div>
      <h3 style="margin: 2px 0px;">{{ cardData.expertise }}</h3>
      <div v-html="cardData.description"></div>
      <!-- <div v-for="(social, key) in cardData.socials" :key="key">
        <div class="cardRow">
          <h6>{{ social.smsplatform }}</h6>
          <h6>{{ social.account }}</h6>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "cardprofile",
  props: {
    cardData: {
      type: Object
    },
  },
  computed: {
  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/msma/components/CardProfile/index.vue